import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.shipping;
export const shippingRoute = {
    path: rootPath,
    lazy: async () => {
        const { ShipmentsContainer } = await import('@/admin/modules/shipping');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(ShipmentsContainer, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
